import { call, put } from '@redux-saga/core/effects'
import axios from 'axios'
import { Action } from '../../../../common/store/sagas/root'
import { deletedItem } from '../../../types'
import { keyDeleteError, keyDeleteSuccess } from '../../../actions/hipUsers/actions'
import { keyDelete } from '../../../api/keyDelete'

export function* sagaKeyDelete({ payload }: Action<number>) {
  try {
    const response: deletedItem = yield call(keyDelete, payload)
    yield put(keyDeleteSuccess(response))
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      yield put(keyDeleteError(error.response.data as unknown))
    } else {
      yield put(keyDeleteError(error))
      throw error
    }
  }
}
